export * from './tokens'

export const LANG_ENG = 'eng'
export const LANG_URD = 'urd'
